import 'pages/Forbidden/Forbidden.scss';
import forbidden from 'pages/Forbidden/images/forbidden@2x.png';
import { useTranslation } from 'react-i18next';

export const MissingOrganization = () => {
  const { t } = useTranslation();
  return (
    <div className='forbidden-page'>
      <div className='text-container'>
        <p className='header'>{t('organization.none')}</p>
        <p className='subtext'>{t('organization.description')}</p>
      </div>
      <div className='image-container'>
        <img src={forbidden} alt='missing-organization' />
      </div>
    </div>
  );
};

export default MissingOrganization;
